module.exports = __webpack_public_path__ + "img/aerial_work_platforms.fe9197a2.jpg";